import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import type { Dispatch } from "redux";
import ExportPageFd from "../../components/ExportPageFd";
import { closeExportPageDialog, startExportPage } from "../../actions/pageActions";
import { getIsPageExporting } from "../../selectors/loading";
import { getIsPageExportingOpen, getExportingSelectedPage } from "../../selectors/pageActions";
import type { State } from "../../pages/AppStoreWrapper";
import type { StateToProps, DispatchToProps, Props } from "./types/ExportPageDialog.type";

const mapStateToProps: (state: State) => StateToProps = (state) => ({
  isOpen: getIsPageExportingOpen(state),
  selectedPage: getExportingSelectedPage(state),
  isPageExporting: getIsPageExporting(state),
});

const mapDispatchToProps: (arg0: Dispatch<any>) => DispatchToProps = dispatch => ({
  ...bindActionCreators({
    startExport: startExportPage,
    closeDialog: closeExportPageDialog,
  }, dispatch),
});

function ExportPageDialog({
  isOpen,
  isPageExporting,
  selectedPage,
  startExport,
  closeDialog,
}: Props) {
  return (
    <ExportPageFd
      open={isOpen}
      exporting={isPageExporting}
      page={selectedPage}
      onApply={startExport}
      onClose={closeDialog}
    />
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ExportPageDialog);
